import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import { injectIntl } from "react-intl";
import { GohubLogo } from "../common/icons/GohubLogo";

import HUBContext from "../services/HUBContext";
import { EdenredLogo } from "../common/icons/EdenredLogo";

const styles = (theme) => ({
  loadInWidget: {
    position: "absolute",
    top: "0px",
    left: "-1px",
    width: "calc(100% + 2px)",
    height: "calc(100% + 1px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderRadius: "15px",
    zIndex: 10,
  },
  pulse: {
    width: "150px",
    height: "60px",
    maxHeight: "100%",
    maxWidth: "100%",
    animation: "pulse 2s ease-in infinite",
  },
});

export class LoadInWidget extends Component {
  render() {
    const { classes, xtraClass, edenredLogo } = this.props;

    return (
      <div
        className={`${classes?.loadInWidget || ""} loadInWidget ${xtraClass || ""}`}
      >
        {edenredLogo ? <EdenredLogo /> : <GohubLogo />}
      </div>
    );
  }
}

LoadInWidget.contextType = HUBContext;

export default withStyles(styles)(injectIntl(LoadInWidget));
